import { Project } from "../../models/Project";
import { Container } from "./styles";
import { images } from "utils/images";
import { Link } from "react-router-dom";
import ProjectCardFooter from "components/ProjectCardFooter/ProjectCardFooter";
interface ProjectProps {
  project: Project;
}
const ProjectItem = ({ project }: ProjectProps) => {
  return (
    <Container>
      <div className="project" key={project.id}>
        <header>
          <h3>{project.name}</h3>
          <div className="project-links">
            <a href={project.github} target="_blank" rel="noreferrer">
              <img
                src={images.githubIcon}
                alt="Visit site"
                width={30}
                height={30}
              />
            </a>
            {project.isDeployed && (
              <a href={project.link} target="_blank" rel="noreferrer">
                <img
                  src={images.externalLink}
                  alt="Visit site"
                  width={30}
                  height={30}
                />
              </a>
            )}
          </div>
        </header>
        <Link
          to={`/project-details/${project.id}`}
          style={{ cursor: "pointer", textDecoration: "none", color: "white" }}
        >
          <div className="body">
            <img
              src={project.image}
              alt={project.name}
              className="projectImage"
            />
            <p className="truncate-description">{project.description}</p>
          </div>
        </Link>
        <ProjectCardFooter project={project} />
      </div>
    </Container>
  );
};

export default ProjectItem;
